import { useQuery } from '@tanstack/react-query';

import userAccountQueries from '@carers/utils/AccountQueryFactory';

const useGetUserAccount = () => useQuery(userAccountQueries.detail());

export default useGetUserAccount;
